module.exports = __webpack_public_path__ + "351741b7b159a8cccb21ff29d91ab2b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/arabicTexture.jpg
// module id = 2649
// module chunks = 0